import { LAST_UPDATED, PRIVACY_SECTIONS, SITE_NAME } from "@/lib/legal";

export default function Privacy() {
    return (
        <div className="max-w-3xl mx-auto px-6 md:px-8 py-12" data-testid="privacy-page">
            <div className="text-[#ff4500] text-xs uppercase tracking-[0.3em] mb-2">Legal</div>
            <h1 className="font-display text-5xl tracking-wide">Privacy Policy</h1>
            <div className="text-xs uppercase tracking-[0.2em] text-[#a0a0a0] mt-3">Last updated: {LAST_UPDATED}</div>
            <div className="h-px bg-[#2a2a2a] my-8" />

            <p className="text-sm text-[#cfcfcf] leading-relaxed mb-8">
                This Privacy Policy describes how <strong>{SITE_NAME}</strong> collects, uses, and shares information
                about you when you use the Service. By using the Service, you agree to the practices described here.
            </p>

            <div className="space-y-8 text-[#cfcfcf] leading-relaxed">
                {PRIVACY_SECTIONS.map((sec) => (
                    <section key={sec.heading}>
                        <h2 className="font-display text-2xl tracking-wide text-white mb-3">{sec.heading}</h2>
                        {sec.paragraphs.map((p, i) => (
                            <p key={i} className="mb-3 text-sm">{p}</p>
                        ))}
                    </section>
                ))}
            </div>
        </div>
    );
}
